const MESSAGES = {
  issues_disabled: 'Enable issue reporting in the app’s GitLab configuration.',
  issue_unconfigured: 'Configure a GitLab API URL, project and token for this app.',
  issue_token_required: 'Enter a GitLab token for this app and destination before enabling issue reporting.',
  issue_credentials_unavailable: 'GitLab credentials are unavailable. An administrator must check credential storage before retrying.',
  issue_config_invalid: 'The saved GitLab issue configuration is invalid.',
  issue_instance_changed: 'This report belongs to the app’s previous GitLab destination. Its original issue link is preserved.',
  http_401: 'GitLab rejected the configured credential. Ask an administrator to update it.',
  http_403: 'The configured credential cannot access this GitLab project.',
  http_404: 'GitLab could not find the project, branch, or issue. Check the configuration and access.',
  http_429: 'GitLab is limiting requests. Please try again later.',
  issue_unreachable: 'GitLab could not be reached. Please try again later.',
  issue_branch_invalid: 'The configured branch does not exist or cannot be accessed.',
  issue_project_invalid: 'The configured GitLab project does not match or cannot accept issues.',
  issue_creation_uncertain: 'GitLab may already have created this issue. Check the project and link the existing issue number to recover the report.',
};

export function errorIssueMessage(code) {
  return MESSAGES[code] ?? 'GitLab issue reporting is unavailable. Check the saved configuration and try again.';
}

export function safeIssueUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
  } catch {
    return null;
  }
}
